export default {
  mfaInfo: 'MFA 信息',
  totp: 'MFA 设备',
  mobile: '安全手机',
  email: '安全邮箱',
  phoneNumber: '手机号',
  emailAddress: '邮箱',
  bind: '绑定',
  unbind: '解绑',
  unbound: '未绑定',
  areYouSureYouWantToUnbind_name: '确定要解绑{name}？',
  pleaseEnterYourPasswordToUnbind: '请输入密码解绑',
  pleaseEnterThePassword: '请输入密码',
  passwordCannotBeEmpty: '密码不能为空',
  name_unbindingSuccessful: '{name}解绑成功!',
  name_bindingSuccessful: '{name}绑定成功!',
  totpDeviceHasBeenBound: '已绑定TOTP设备',
  bindSecurityMobile: '绑定安全手机',
  bindSecurityEmail: '绑定安全邮箱',
  bindVirtualMfa: '绑定虚拟 MFA',
  selectMfaTypeToBind: '选择绑定的 MFA 类型',
  bindMobileTips: '绑定安全手机后，在登录或发生风险操作时会进行二次验证，阻拦潜在的异常行为，可以更好地保障您的账户安全。',
  bindEmailTips: '绑定安全邮箱后，在登录或发生风险操作时会进行二次验证，阻拦潜在的异常行为，可以更好地保障您的账户安全。',
  bindVirtualMfaTips1: '1.使用虚拟 MFA应用程序进行扫码或手动输入密钥。若应用程序已有同名设备，需要删除后重新绑定。',
  bindVirtualMfaTips2: '2.输入MFA应用程序展示的6位安全码。',
  selectMfaTypeToBindTips1: '根据您的账号设置，您需要启用MFA设备以完成登录',
  selectMfaTypeToBindTips2: '点击选项，选择不同的MFA设备进行绑定。',
  pleaseEnterThePhonenumber: '请输入手机号',
  pleaseEnterTheEmail: '请输入邮箱',
  pleaseEnterTheCode: '请输入验证码',
  phoneNumberCannotBeEmpty: '手机号不能为空',
  emailCannotBeEmpty: '邮箱不能为空',
  pleaseEnterTheCorrectFormat: '请输入正确格式',
  codeCannotBeEmpty: '验证码不能为空',
  pleaseEnterThe_6DigitCode: '请输入6位数验证码',
  codeHasBeenSentTo_emailOrPhone: '验证码已发送至{emailOrPhone}',
  count_Resend: '{count}s 后重新获取',
  getCode: '获取验证码',
  copySecretKey: '复制密钥',
  pleaseEnterThe_6DigitSecurityCode: '请输入6位数字安全码',
  securityCodeCannotBeEmpty: '安全码不能为空',
  confirm: '确定',
  cancel: '取消',
  copySuccessful: '复制成功',
  copyFailed: '复制失败',
  theSecretKeyDoesNotExist: '密钥不存在',
  bindOtherMfaTypes: '绑定其他 MFA 类型',
  bindEmailViaEmailVerificationCode: '通过邮箱收取验证码来绑定邮箱。',
  bindMobileViaSmsVerificationCode: '通过短信验证码来绑定手机号。',
  bindByScanningWithMobileMfaApp: '通过手机上的MFA验证程序进行扫码绑定。',
  submitVerification: '提交验证',
  username: '用户名',
  securityCode: '安全码',
  captcha: '验证码',
  loginVerificationPrompt: '为确保账号 {account} 是您本人操作，请任意选择一种方式验证身份。',
  verificationSuccessful: '验证成功!',
  verificationFreeLogin: '30天免验证登录'
}
